<template>
  <div class="ConfirmDelete big-container h-screen flex justify-center py-20">
    <div
      class="flex justify-center items-center w-11/12 lg:w-2/3 bg-white"
    >
      <div>
        <icon :data="icons.Valid" height="100" width="100" original class="" />
        <div class="w-4/5 font-c7 text-c24 mx-auto mt-5">
          Demande de suppression envoyée !!
        </div>
        <div class="w-11/12 lg:w-2/5 mx-auto mt-3">
          Votre demande de suppression a bien été prise en compte. Notre équipe
          procédera à son traitement dans de brefs délais.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Valid from "../../../assets/icons/ic_valid.svg";

export default {
  name: "Index",

  components: {},

  data() {
    return {
      icons: {
        Valid,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.big-container {
  width: 100%;
  background-color: #e8e7f0;
}
.card2 {
  background-color: #fd3a300f;
}

.txt1 {
  color: #fd3a30;
  font-size: 20px;
  font-weight: 700;
}
.txt2 {
  color: #7b829b;
  font-size: 14px;
  font-weight: 500;
}

.txt3 {
  color: #4679fa;
  font-size: 14px;
  font-weight: 500;
}
</style>
